import './sw-cms-el-acris-blog-subtitle.scss';

const { Mixin } = Shopware;

/**
 * @private
 * @sw-package discovery
 */
export default {
    mixins: [
        Mixin.getByName('cms-element'),
    ],

    computed: {
        isBlogPage() {
            return this.cmsPageState?.currentPage?.type ?? '' === 'cms_blog';
        },
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-subtitle');

            if (this.isBlogPage && !this.element?.translated?.config?.content) {
                this.element.config.content.source = 'mapped';
                this.element.config.content.value = 'acris_blog.subtitle';
            }
            this.updateDemoValue();
        },

        updateDemoValue() {
            if (this.element.config.content.source === 'mapped') {
                let label = '';
                let className = 'sw-cms-el-acris-blog-subtitle__skeleton';

                if (this.element.config.content.value === 'acris_blog.subtitle') {
                    className = 'sw-cms-el-acris-blog-subtitle__placeholder';
                    label = this.$tc('acris-blog.elements.blogSubtitle.preview.subtitle');
                }

                this.demoValue = `<h3 class="${className}">${label}</h3>`;

                if (this.cmsPageState.currentDemoEntity) {
                    this.demoValue = this.getDemoValue(this.element.config.content.value);
                }
            }
        },
    },
};